






import { Component, Vue, Prop } from 'vue-property-decorator'
import { Game } from '@/class/game'
import LogViewer from './Log/LogViewer.vue'
import NightActionResultMessages from './nightActionResult/NightActionResult.vue'
import HeadlineBorder from '@/components/Utils/headline/HeadlineBorder.vue'
import { GamePlayer } from '@/class/gamePlayer'

@Component({
  components: {
    LogViewer,
    NightActionResultMessages,
    HeadlineBorder,
  }
})

export default class Play extends Vue {
  @Prop() game!: Game;
  @Prop() playerSelf?: GamePlayer;

  get playerId () {
    return this.playerSelf?.id
  }

  get nightLogs () {
    return this.game.historyLogs.filter(log => log.nightAction)
  }
}
